<template>
    <div class="columns is-multiline is-mobile">
        <div class="column is-1-tablet is-one-quarter-mobile">
            <a :href="productRoute + '/' + item.meta.slug[lang]" target="_blank"><img
                :src="item.meta.featured_image_url[lang]" :alt="item.meta.name[lang]"></a>
        </div>
        <div class="column is-4-tablet is-three-quarters-mobile">
            <a :href="productRoute + '/' + item.meta.slug[lang]" target="_blank"><h2
                class="cart-wrap-product-name">{{ item.meta.name[lang] }}</h2></a>
            <div class="mt-4 is-hidden-tablet">
                <a
                    href="javascript:;"
                    class="button is-inline-block button--count"
                    @click="$parent.removeFromCart(item.meta.id)"
                >-</a>
                <div class="is-inline-block mx-2">
                    <input v-model="quantity" @blur="countFocusOut" type="text" step="1" min="1" class="product-quantity">
                </div>
                <a
                    href="javascript:;"
                    class="button is-inline-block button--count"
                    @click="$parent.addToCart(item.meta.id)"
                >+</a>
            </div>
            <div class="mt-4 is-hidden-tablet">
                {{ item.meta.price_formatted }}
                <br>
                {{ i18n.spolu }}: <b>{{ item.price_formatted }}</b> <a href="javascript:void(0);"
                                                               @click="$parent.removeItemsFromCart(item.meta.id)"
                                                               class="blue-link ml-2"><span class="material-icons">delete</span></a>
            </div>
        </div>
        <div class="column text-center is-3-tablet is-full-mobile is-hidden-mobile">
            <a
                href="javascript:;"
                class="button button--count is-inline-block"
                @click="$parent.removeFromCart(item.meta.id)"
            >-</a>
            <div class="is-inline-block mx-2">
                <input v-model="quantity" @blur="countFocusOut" type="text" step="1" min="1" class="product-quantity">
            </div>
            <a
                href="javascript:;"
                class="button is-inline-block button--count"
                @click="$parent.addToCart(item.meta.id)"
            >+</a>
        </div>
        <div class="column text-center is-2-tablet is-full-mobile  is-hidden-mobile">
            {{item.meta.price_formatted}} {{ i18n.lomeno_ks }}
        </div>
        <div class="column text-center is-2-tablet is-full-mobile  is-hidden-mobile">
            <b>{{ item.total_price_formatted}}</b> <a href="javascript:void(0);"
                                                    @click="$parent.removeItemsFromCart(item.meta.id)"
                                                    class="blue-link ml-2"><span
            class="material-icons">delete</span></a>
        </div>
    </div>
</template>

<script>
export default {
    name: "CartRowComponent",
    props: {
      item: {},
      productRoute: String,
    },
    data: function () {
        return {
            quantity: this.item.count,
		  	lang: document.documentElement.lang,
            i18n: i18n
        };
    },
    methods: {
        async countFocusOut()
        {
            let q = parseInt(this.quantity);

            if (this.quantity && !Number.isInteger(q)) {
                this.quantity = this.item.count;
            }

            if (q < 1) {
                this.quantity = this.item.count;
            }

            try {
                await this.$parent.addToCart(this.item.meta.id, this.quantity - this.item.count);
            } catch (e) {
                this.quantity = this.item.count;
            }
        }
    },
    watch: {
        item: {
            handler() {
                this.quantity = this.item.count;
            }
        }
    }
}
</script>

<style scoped>

</style>
